import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteFacilityRuleMutationAtom = createMutationAtomFactory(
  'settings.complianceFacilityRuleDelete',
  ({ id }: { id: string }) => ({
    complianceComplianceFacilityRuleDelete: {
      __args: {
        id,
      },
    },
  }),
);
